import React, { useContext } from 'react';
// import images
import soroush from '../img/about/soroush1.jpg';
// import link
import { Link } from 'react-router-dom';
// import motion
import { motion } from 'framer-motion';
// import transition
import { transition1 } from '../transitions';
import {ImInstagram, ImLinkedin} from 'react-icons/im';

const About = () => {
  return (
    <motion.section
      initial={{ opacity: 0, y: '100%' }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: '100%' }}
      transition={transition1}
      className='section'
    >
      <div
        className='container mx-auto h-full relative '
      >
        {/* text & img wrapper */}
        <div className='flex flex-col lg:flex-row h-full items-center justify-center gap-x-24 text-center lg:text-left  lg:pt-16 overflow-hidden'>
          {/* image */}
          <div className='flex-1 mt-72  max-h-96 lg:max-h-max order-2 lg:order-none overflow-hidden relative'>
            <div className='absolute flex flex-1 m-2 gap-2 top-0 right-0'>
            <a className='hover:text-yellow-400' href='http://www.instagram.com/__.soroush.__' target='_blank' rel="noreferrer">              
              <ImInstagram size={30} className='text-gray-700 hover:text-white '/>
              </a>
              <a className='hover:text-yellow-400' href='https://www.linkedin.com/in/soroush-bahrami-ba691b19b/' target='_blank' rel="noreferrer">
              <ImLinkedin size={30} className='text-gray-700 hover:text-white '/>
              </a>
            </div>
            <img src={soroush} alt=''/>
          </div>

          
          {/* text */}
          <motion.div
            initial={{ opacity: 0, y: '-80%' }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: '-80%' }}
            transition={transition1}
            className='flex-1 mt-56 pt-36 pb-14 lg:pt-0 lg:w-auto z-10 flex flex-col justify-center items-center lg:items-start'
          >
            <img className="mt-36 w-20 h-30 lg:hidden sm:hidden rounded-full" src={soroush} alt="Rounded avatar"/>

            <h1 className='h1'>About me</h1>
            <p className='mb-12 w-4/5'>
            Welcome to my Photography Portfolio! I'm Soroush, a fervent film photographer nestled in the vibrant heart of Toronto. 
            <br/>
            In the pursuit of capturing moments that often slip through the cracks, I've discovered a profound appreciation for the beauty hidden in the seemingly mundane.
            </p>
            <Link to={'/works'} className='btn mb-16'>
              View my work
            </Link>
          </motion.div>
        </div>
      </div>
    </motion.section>
  );
};

export default About;
